"use client";
import React from "react";

interface BorderLineProps {
  /** horizontal | vertical */
  direction?: "horizontal" | "vertical";

  /** thickness of the line */
  size?: number;

  /** color of the line */
  color?: string;

  /** spacing around the line */
  margin?: string;

  /** extra classes if needed */
  className?: string;

  /** custom styles */
  style?: React.CSSProperties;
}

export default function BorderLine({
  direction = "horizontal",
  size = 1,
  color,
  margin = "8px 0",
  className = "",
  style,
}: BorderLineProps) {
  const isHorizontal = direction === "horizontal";

  // Use theme variable if color not provided
  const lineColor = color || "var(--sidebar-border)";

  return (
    <div
      className={className}
      style={{
        backgroundColor: lineColor,
        height: isHorizontal ? size : "100%",
        width: isHorizontal ? "100%" : size,
        margin,
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
